import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, useLocation } from "react-router-dom";

import App from "./App";
import { KlientApp } from "@/klient/KlientApp";
import { OperatorApp } from "@/operator/OperatorApp";
import { ToastProvider } from "@/components/Toast";

// Marken-Schriften (Fidena) — self-hosted via @fontsource (kein Google-CDN,
// DSGVO-konform + offline-robust im Kanzlei-Netz). Variable Fonts = ein
// Gewicht-Spektrum pro Datei. Fraunces = Editorial-Serif (Marke/Headlines),
// Inter = UI/Body, JetBrains Mono = Zahlen/Steuernummern (tabular).
import "@fontsource-variable/fraunces";
import "@fontsource-variable/inter";
import "@fontsource-variable/jetbrains-mono";

import "./styles/global.css";

// React-Query Defaults:
// - 30s staleTime, damit Re-Renders nicht jeden Refocus retriggern.
// - retry: 1, weil im LAN-Umfeld Hartnaeckigkeit oft unnoetigen Spam erzeugt.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

// Router-Split: Der Klient-Bereich (/klient/...) ist eine eigene, oeffentliche
// Welt OHNE das Sachbearbeiter-Auth-Gate (App ruft useCurrentUser bedingungslos).
// Per useLocation entscheiden, statt verschachtelter Routes — vermeidet
// Pfad-Konflikte mit Apps absoluten Routen.
function Root() {
  const location = useLocation();
  if (location.pathname.startsWith("/klient")) {
    return <KlientApp />;
  }
  if (location.pathname.startsWith("/operator")) {
    return <OperatorApp />;
  }
  return <App />;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ToastProvider>
          <Root />
        </ToastProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
